import { DateRangePickerProps } from "@amzn/awsui-components-react";
import { getString } from "common/ui-string-labels/ui-strings-utils";

export const START_OF_DAY_SUFFIX = "T00:00:00Z";
export const END_OF_DAY_SUFFIX = "T23:59:59Z";
export const DATE_RANGE_STRING_PATH = "manageOrders.table.dateRangeFilter";

/**
 * Validates that the selected date range is valid (start date is not after end date).
 *
 * @param value - The current DateRangePicker value
 * @returns ValidationResult indicating whether the range is valid
 */
export const validateDateRange = (value: DateRangePickerProps.Value | null): DateRangePickerProps.ValidationResult => {
    if (value?.type === "absolute" && value.startDate && value.endDate) {
        if (new Date(value.startDate) > new Date(value.endDate)) {
            return { valid: false, errorMessage: getString(`${DATE_RANGE_STRING_PATH}.errorInvalidRange`) };
        }
    }
    return { valid: true };
};

/**
 * Converts a DateRangePicker absolute value to the filter format expected by the ITO API.
 * Uses local time interpretation (no Z suffix) to match how the frontend displays dates.
 *
 * @param dateRangeValue - The current DateRangePicker value, or null if cleared
 * @returns The filter entry as [fromISO, toISO], or null if no filter should be applied
 */
export const buildDateRangeFilter = (dateRangeValue: DateRangePickerProps.Value | null): string[] | null => {
    if (!dateRangeValue || dateRangeValue.type !== "absolute") {
        return null;
    }

    const fromISO = dateRangeValue.startDate
        ? new Date(dateRangeValue.startDate + START_OF_DAY_SUFFIX).toISOString()
        : "";
    const toISO = dateRangeValue.endDate
        ? new Date(dateRangeValue.endDate + END_OF_DAY_SUFFIX).toISOString()
        : "";

    return [fromISO, toISO];
};
